import apiYtAgent from '../../helpers/apiYtAgent';

const connectionPath = 'api/channels/whatsapp/connection';

export async function getWhatsAppConnection(signal) {
  const response = await apiYtAgent.get(connectionPath, {
    signal
  });

  const data = response.data;

  if (!data || typeof data.connected !== 'boolean') {
    throw new Error(
      'A API retornou um status de conexão inválido.'
    );
  }

  return {
    connected: data.connected,
    externalIdentifierMasked: data.externalIdentifierMasked || null,
    verifiedAtUtc: data.verifiedAtUtc || null
  };
}

export async function createWhatsAppChallenge() {
  const response = await apiYtAgent.post(
    `${connectionPath}/challenge`
  );

  const data = response.data;

  if (
    !data ||
    typeof data.code !== 'string' ||
    !data.code.trim() ||
    typeof data.expiresAtUtc !== 'string' ||
    !Number.isFinite(Date.parse(data.expiresAtUtc))
  ) {
    throw new Error(
      'A API retornou um código de conexão inválido.'
    );
  }

  return {
    code: data.code,
    expiresAtUtc: data.expiresAtUtc
  };
}

export async function disconnectWhatsApp() {
  await apiYtAgent.delete(connectionPath);
}